export const COOKIE_SERVICE = "CookieService";
